import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {filter, map, switchMap} from 'rxjs/operators';
import {ReviewService} from '../review.service';
import {AsyncPipe, NgIf} from '@angular/common';

@Component({
    selector: 'app-review-buttons',
    templateUrl: './review-buttons.component.html',
    styleUrls: ['./review-buttons.component.css'],
    imports: [
        AsyncPipe,
        NgIf
    ]
})
export class ReviewButtonsComponent implements OnInit {
  @Input() recordId: string;
  @Input() modalInstance: NgbActiveModal;

  public review: Observable<any>;

  constructor(private reviewService: ReviewService) {
  }

  ngOnInit(): void {
    this.review = this.reviewService.loadMetadata().pipe(
        switchMap(() => this.reviewService.getList({current_user: true, record_id: this.recordId})),
        filter(r => r.results.length > 0),
        map(r => r.results[0])
      );
  }

  public approve(review) {
    review.status = this.reviewService.meta.approve_value;
    this.reviewService.save(review).subscribe(() => {
      this.modalInstance.close()
    });
  }

  public reject(review) {
    review.status = this.reviewService.meta.reject_value;
    this.reviewService.open_modal(this.recordId, review)
      .then(() => {
        this.modalInstance.close()
      })
      .catch(() => {
        review.status = 'needed'
      });
  };
}
